import { ButtonDefault } from '@/components/common/Button'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { usePage } from '@/components/providers/PageProvider'
import { ARTICLE_URLS } from '@/defs/misc'
import { cn } from '@/utils/commonUtil'
import { formatPercentage } from '@/utils/formatUtil'

import { FeaturedComboHeading } from '../FeaturedComboHeading/FeaturedComboHeading'

import styles from './FeaturedComboVote.module.scss'

type ChartProps = {
  label: string
  percentage: number
}

const Chart = ({ label, percentage }: ChartProps) => {
  const percentageLabel = formatPercentage(percentage)

  const level = percentage < 0.4 ? 'low' : percentage < 0.5 ? 'middle' : 'high'

  return (
    <div className={cn(styles.chart, { level, styles })}>
      <div className={styles.label}>{label}</div>
      <div className={styles.bar}>
        <div className={styles.fill} style={{ width: `${percentage * 100}%` }} />
        <div className={styles.percentage}>{percentageLabel}%</div>
      </div>
    </div>
  )
}

export const FeaturedComboVote = () => {
  const { page } = usePage()

  const vote = page?.featuredCombo?.vote

  if (!vote) return null

  const { earlyScore, prereqScore, resultScore } = vote

  return (
    <div className={styles.container}>
      <FeaturedComboHeading
        heading='Combo Voting'
        icon='handshake'
        subheading={
          <>
            Does the community think this a true 2-card combo (<em>both</em> trivial prerequisites and significant
            results)? Do they think it can be executed before turn 6 or so?
          </>
        }
      />
      <div className={styles.chartsList}>
        {prereqScore !== undefined && <Chart label='Trivial Prerequisites' percentage={prereqScore} />}
        {resultScore !== undefined && <Chart label='Significant Results' percentage={resultScore} />}
        {earlyScore !== undefined && <Chart label='Early Game' percentage={earlyScore} />}
      </div>
      <div className={styles.buttonWrap}>
        <ButtonDefault as='LinkRoute' href={ARTICLE_URLS.BRACKETS}>
          <IconWithLabel iconAfter='caretRight'>Learn more about Brackets</IconWithLabel>
        </ButtonDefault>
      </div>
    </div>
  )
}
